import { supabase } from './supabase';

export const MARKETPLACE_PAGE_SIZE = 30;

export function fetchMarketplacePage(type, { query = '', date = '', status = '', cursor = null } = {}) {
  const pageSize = MARKETPLACE_PAGE_SIZE + 1;
  if (type === 'trips') {
    return supabase.rpc('search_active_trips_with_capacity', {
      p_query: query.trim() || null,
      p_travel_date: date || null,
      p_after_date: cursor?.travel_date || null,
      p_after_id: cursor?.id || null,
      p_page_size: pageSize,
    });
  }
  if (type === 'offers') {
    return supabase.rpc('search_active_local_errands_with_capacity', {
      p_query: query.trim() || null,
      p_planned_date: date || null,
      p_after_date: cursor?.planned_date || null,
      p_after_id: cursor?.id || null,
      p_page_size: pageSize,
    });
  }
  if (type === 'orders') {
    return supabase.rpc('search_my_orders', {
      p_query: query.trim() || null,
      p_status: status || null,
      p_after_created_at: cursor?.created_at || null,
      p_after_id: cursor?.id || null,
      p_page_size: pageSize,
    });
  }
  throw new Error(`Unsupported marketplace page type: ${type}`);
}
